import { createContext, useContext } from 'react';

export const PortfolioProjectRequestsContext = createContext();

export const usePortfolioProjectRequestsContext = () =>
  useContext(PortfolioProjectRequestsContext);

export default PortfolioProjectRequestsContext;
